/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jun 22 2023
 **/

import styled from "@emotion/styled";

import { Column, Row, Typography } from "@/frameworks/designStuff/components";

export const MiniPopupWrapper = styled(Column)`
	position: sticky;
	padding: 0;
	min-width: 360px;
	min-height: 520px;
	width: 100%;
	height: 100%;
	background: ${({ theme }) => theme.colors.neutral_00_84};
	box-shadow:
		0 0 4px rgba(0, 0, 0, 0.04),
		0 12px 20px rgba(0, 0, 0, 0.2);
	border-radius: 12px;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: inherit;
		backdrop-filter: blur(14px);
		border-radius: 12px;
		z-index: -1;
	}
`;

export const Header = styled(Row)<{ topBarColor: string; type: "Space" | "DM"; focus: boolean }>`
	width: -webkit-fill-available;
	padding: 4px 4px 4px 12px;
	border-top-right-radius: 12px;
	border-top-left-radius: 12px;
	background: ${({ theme, topBarColor, type, focus }) => {
		if (type === "Space") {
			if (topBarColor === theme.colors.gradient_40_100_w60) {
				return focus ? theme.colors.gradient_40_100_w60 : theme.colors.gradient_40_100_w80;
			} else return topBarColor;
		}
		return focus ? theme.colors.gradient_40_100_w60 : theme.colors.gradient_40_100_w80;
	}};
	opacity: ${({ focus }) => !focus && 0.5};
	flex-direction: column;
`;

export const RoomInfo = styled(Column)`
	width: fit-content;
	min-width: 100px;
	padding: 4px;
	border-radius: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.secondary_80_12};
	}
`;

export const EmojiPickerWrapper = styled(Column)`
	position: absolute;
	bottom: 100%;
`;

export const ChannelUserListWrapper = styled(Typography)`
	max-width: calc(100% - 20px);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	word-break: break-all;
`;

export const SearchField = styled(Row.div)`
	padding: 0 16px;
`;

export const EmptySearch = styled(Column)`
	width: 100%;
	height: 100%;
	padding: 20px;
`;
